// @flow

import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Glide        from '@glidejs/glide';

class ItemSlider extends WebComponent {

	constructor(props) {
		super(props);
		this.itemSlider = null;
		this.arrowLeft = null;
		this.arrowRight = null;
		this.items = null;
		this.buildArrows = this.buildArrows.bind(this);
		this.buildBullets = this.buildBullets.bind(this);
		this.updateBullets = this.updateBullets.bind(this);
		this.handleArrow = this.handleArrow.bind(this);
	}

	didMount() {
		this.items = [ ...this.element.querySelectorAll('.item-slider__slide') ];

		if ( this.items.length > 1 ) {

			this.buildArrows();
			this.arrowLeft = this.element.querySelector('.item-slider__arrow--left');
			this.arrowRight = this.element.querySelector('.item-slider__arrow--right');

			this.buildBullets();
			this.bullets = this.element.querySelector('.item-slider__bullets');

			this.itemSlider = new Glide(this.element, this.props);

			this.itemSlider.on('resize', () => {
				this.itemSlider.go('=0');

				this.updateBullets();
				this.updateArrows();
			});

			// this.arrowLeft.addEventListener('click', this.handleArrow);
			// this.arrowRight.addEventListener('click', this.handleArrow);

			this.updateBullets();
			this.updateArrows();

			this.itemSlider.mount();
		}
	}

	willUnMount() {
		// this.arrowLeft.removeEventListener('click', this.handleArrow);
		// this.arrowRight.removeEventListener('click', this.handleArrow);
		this.itemSlider.destroy();
	}

	/**
	 * Renders control arrows
	 */
	buildArrows() {
		const {
			      messages,
		      } = this.props;

		if ( this.items.length > 1 ) {
			const prevClasses = [
				'widget-controls__item',
				'widget-controls__item--prev',
				'item-slider__arrow',
				'item-slider__arrow--prev',
				'item-slider__control',
				// 'glide__arrow',
				// 'glide__arrow--left',
			];
			const nextClasses = [
				'widget-controls__item',
				'widget-controls__item--next',
				'item-slider__arrow',
				'item-slider__arrow--next',
				'item-slider__control',
				// 'glide__arrow',
				// 'glide__arrow--right',
			];
			let arrowsCode = '<div class="item-slider__arrows widget-controls glide__arrows" data-glide-el="controls">';
			// eslint-disable-next-line max-len
			arrowsCode += `<button rel="prev" data-glide-dir="<" class="${ prevClasses.join(' ') }">${ (messages.prev || '') }</button>`;
			// eslint-disable-next-line max-len
			arrowsCode += `<button rel="next" data-glide-dir=">" class="${ nextClasses.join(' ') }">${ (messages.next || '') }</button>`;
			arrowsCode += '</div>';

			this.element.innerHTML += arrowsCode;
		}
	}

	/**
	 * Renders control bullets
	 */
	buildBullets() {

		if ( this.items.length > 1 ) {
			let html = '<div class="item-slider__bullets" data-glide-el="controls[nav]">';

			this.items.forEach((item, index) => {
				html += `<button class="item-slider__bullet item-slider__control" data-glide-dir="=${ index }">`;
				html += `${ (item.getAttribute('data-webslider-title') || index) }</button>`;
			});

			html += '</div>';
			this.element.innerHTML += html;
		}
	}

	updateBullets() {
		const { perView } = this.itemSlider.settings;
		const pages = Math.ceil(this.items.length / perView);
		let page = 1;
		const buttons = this.bullets.querySelectorAll('button');

		for ( let i = 0; i < buttons.length; i++ ) {
			if ( ((i % perView === 0) && (page <= pages)) || (((buttons.length - i) === perView)) ) {
				page++;
				buttons[ i ].classList.remove('hide');
			} else {
				buttons[ i ].classList.add('hide');
			}
		}
	}

	updateArrows() {
		//
	}

	handleArrow() {
		// glidejs nepusti click eventu
	}
}

ItemSlider.defaultProps = {
	type:                'slider',
	startAt:             0,
	perView:             6,
	focusAt:             0,
	gap:                 10,
	autoplay:            false,
	hoverpause:          false,
	keyboard:            true,
	bound:               true,
	swipeThreshold:      80,
	dragThreshold:       120,
	perTouch:            false,
	touchRatio:          0.5,
	touchAngle:          45,
	animationDuration:   400,
	rewind:              false,
	rewindDuration:      800,
	animationTimingFunc: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
	direction:           'ltr',
	peek:                0,
	throttle:            25,
	breakpoints:         {
		480: {
			perView: 1,
		},
		800: {
			perView: 2,
		},
	},
	classes:             {
		direction:     {
			ltr: 'item-slider--ltr',
			rtl: 'item-slider--rtl',
		},
		slider:        'item-slider--slider',
		carousel:      'item-slider--carousel',
		swipeable:     'item-slider--swipeable',
		dragging:      'item-slider--dragging',
		cloneSlide:    'item-slider__slide--clone',
		activeNav:     'item-slider__bullet--active',
		activeSlide:   'item-slider__slide--active',
		disabledArrow: 'item-slider__arrow--disabled',
	},
};

export default ItemSlider;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ItemSlider.js